import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-matches-list',
  templateUrl: './matches-list.component.html',
  styleUrls: ['./matches-list.component.css']
})
export class MatchesListComponent implements OnInit {

  matchList: any;
  isLoading = false;
  matchSubs: Subscription;
  constructor(private matchService: MatchService) { }

  ngOnInit() {
    this.isLoading = true;
    this.matchService.getMatches(true, false, "own", 12);
      this.matchSubs = this.matchService.getUpdateMatchListner()
        .subscribe((response) => {
          //console.log(response);
          this.matchList = response.match;
          this.isLoading = false;
        },
          error => {
            console.log(error);
            this.isLoading = false;
          });
  }
}